import { AuthDataProvider } from './../auth-data/auth-data';
//import { HttpClient, HttpHandler } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFirestore } from 'angularfire2/firestore';
import * as firebase from 'firebase';
import 'firebase/firestore';
//import { snapToArray } from "../helper";
import { Storage } from '@ionic/storage';

@Injectable()
export class StoryProvider {
  private db: any;
  //private story: any;
  public userInfo: any;

  constructor(public firestore: AngularFirestore,
    public auth: AuthDataProvider,
    private storage: Storage) {
    this.db = firebase.firestore();
    let ion = this;
    ion.auth.getUserProfile().then(resdevice => {
      ion.userInfo = resdevice;
      console.log("READDDDIINGGGGGG ", ion.userInfo)
    });
  }

  getChapters(chaptersIDs): Promise<any> {
    let ion = this;
    let arrChapter = [];
    return new Promise((resolve, reject) => {
      chaptersIDs.forEach(chapterID => {
        ion.db.collection('stories').doc(chapterID).get().then(resChap => {
          let objChap = JSON.parse(JSON.stringify(resChap.data()));
          objChap.$key = resChap.id;
          arrChapter.push(objChap);

          if (chaptersIDs.length === arrChapter.length) {
            resolve(arrChapter);
          }
        })
      });
    })
  }

  getCategoriesWithStories() {
    return new Promise((resolve, reject) => {
      //let catPP = 0;
      //let catPO = 0;
      let ion = this;
      let categories = ion.db.collection("categories");
      let stories = ion.db.collection("stories");
      let data = [];

      //Get categories
      categories.get()
        .then(snapShot => {
          snapShot.forEach(categorie => {
            let objCategorie = JSON.parse(JSON.stringify(categorie.data()));
            objCategorie.$key = categorie.id;
            objCategorie.stories = [];
            // Get stories
            stories.where("category", "==", objCategorie.$key).where("status", "==", "1").where("main_chapter", "==", true).get()
              .then(snapShot2 => {
                //catPO = 0;
                snapShot2.forEach(doc => {
                  let objStorie = JSON.parse(JSON.stringify(doc.data()));
                  objStorie.$key = doc.id;
                  // Add storie to categorie object
                  objCategorie.stories.push(objStorie);

                });
                // Push Categorie with storie into data
                data.push(objCategorie);
                if (data.length == snapShot.size && objCategorie.stories.length == snapShot2.size) {
                  resolve(data);
                }
              })
            //Resolve gere asd
          })

        })
        .catch(err => {
          console.log('error obtaining categories.', err);
          reject(err);
        });
    });
  }

  getStoriesChapters(storieID) {
    return new Promise((resolve, reject) => {
      let ion = this;
      //Declaro arreglo
      let arrChapter = [];
      let chapters = ion.db.collection("chapters");
      chapters.where("storyID", "==", storieID).get()
        .then(snapShot => {
          snapShot.forEach(chapter => {
            //Contruyo objeto
            let objChapetr = JSON.parse(JSON.stringify(chapter.data()));
            objChapetr.$key = chapter.id;
            //empujo objeto al arreglo
            arrChapter.push(objChapetr);
          });
          //resuelvo el arreglo entero
          resolve(arrChapter);
        })
        .catch(function (err) {
          console.error('error obtaining chapters.', err);
          reject(err);
        });
    });
  }

  getStory(historyID): Promise<any> {
    return new Promise((resolve, reject) => {
      let ion = this;
      let stories = ion.db.collection("stories");
      stories.doc(historyID).get()
        .then(response => {
          let objStory = JSON.parse(JSON.stringify(response.data()));
          objStory.$key = response.id;
          resolve(objStory);
        })
        .catch(err => {
          console.log('Error obtaining story', err);
        })
    })
  }

  // Cambiar nombre de funcion a getStoriesComments()
  getStoryMessages(storieID): Promise<any> {
    return new Promise((resolve, reject) => {
      let ion = this;
      let messages = ion.db.collection("stories-messages");
      console.log("storieID", storieID);

      messages.where("story_id", "==", storieID).get()
        .then(snapShot => {
          snapShot.forEach(messageStory => {
            let objMessageStory = JSON.parse(JSON.stringify(messageStory.data()));
            objMessageStory.$key = messageStory.id;
            resolve(objMessageStory);
          });
        })
        .catch(function (err) {
          console.error('error obtaining messages.', err);
          reject(err);
        });
    });
  }

  setLike(story_id, like, userInfon, isLike): Promise<any> {
    return new Promise((Resolve, Reject) => {
      let ion = this;
      let stories = ion.db.collection("stories");
      let users = ion.db.collection("users");
      let userInfo = userInfon
      let myLike = isLike
      console.log("MYLIKE", myLike)
      stories.doc(story_id).update({ like: like }).then((snap: any) => {
        ion.storage.get('storiesLikes').then((val) => {

          console.log("VALOR DE VALLLL", val);
          if (val = null) {
            let likes = val;
            let newLike = {
              storyID: story_id,
              like: true
            }
            likes.push(newLike);
            ion.storage.set('storiesLikes', likes);
            console.log("GUARANDO LIKE EN STORAGE 1");
          } else {
            let likes = []
            let newLike = {
              storyID: story_id,
              like: true
            }
            likes.push(newLike);
            ion.storage.set('storiesLikes', likes);
            console.log("GUARANDO LIKE EN STORAGE 2");
          }

          let likesuser = userInfo.likes
          console.log("USERLIKES", userInfo.likes);
          if (likesuser == null || typeof likesuser === "undefined") {
            likesuser = []
            let newLike = {
              storyID: story_id,
              like: true
            }
            likesuser.push(newLike);
            users.doc(userInfo.userID).update({ likes: likesuser }).then((snap: any) => {
              Resolve(true);
            }).catch((error) => {
              console.log(error);
              Reject(error);
            });
          } else {
            let liekExist = false
            console.log("SIZE", likesuser.length);
            for (let ii = 0; ii < likesuser.length; ii++) {
              console.log("USERLIKES", likesuser[ii]);
              if (likesuser[ii].storyID == story_id) {
                if (myLike) {
                  console.log("TRUE")
                  likesuser[ii].like = true
                } else {
                  console.log("TRUE")
                  likesuser[ii].like = false
                }
                liekExist = true
              }
              if (ii == (likesuser.length - 1)) {
                if (liekExist) {
                  users.doc(userInfo.userID).update({ likes: likesuser }).then((snap: any) => {
                    Resolve(true);
                  }).catch((error) => {
                    console.log(error);
                    Reject(error);
                  });
                } else {
                  let newLike = {
                    storyID: story_id,
                    like: true
                  }
                  likesuser.push(newLike);
                  users.doc(userInfo.userID).update({ likes: likesuser }).then((snap: any) => {
                    Resolve(true);
                  }).catch((error) => {
                    console.log(error);
                    Reject(error);
                  });
                }
              }
            }
          }
          //   console.log('OOOOOOOOOOOOOOOOOO', val);
        });
      })
        .catch((error) => {
          console.log(error);
          Reject(error);
        });
    });
  }

  saveView(storieID, view) {
    let ion = this;
    ion.db.collection("stories").doc(storieID).update({ view: view + 1 })
      .then(function () {
        console.log("view added!");
      })
      .catch(function (error) {
        console.error("Error updating comment: ", error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/story/story.ts